import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'

export const getPriceLogsAsync = createAsyncThunk(
  'priceLogs/getPriceLogsAsync',
  async function (
    params: {
      paramData: {page_num: number; page_limit?: number; sort_by: string; sort_order: string;status:string;from_date?:string;to_date?:string;
      platform_id:string; variant_id?: any }

    },
    toolkit
  ) {
    return await AxiosClient(
      'GET',
      `/api/product-price-changes-logs`,
      [],
      toolkit,
      params.paramData
    )
  }
)

export const resyncFailedPriceChangeAsync = createAsyncThunk(
  'priceLogs/resyncFailedPriceChangeAsync',
  async function (
    params: {product_variant_id: number | null; sync_id: number | null},
    toolkit
  ) {
    const query = new URLSearchParams({
      product_variant_id:
        params.product_variant_id === null ? 'null' : String(params.product_variant_id),
      sync_id: params.sync_id === null ? 'null' : String(params.sync_id),
    }).toString()
    return await AxiosClient(
      'POST',
      `/api/resync-failed-price-change?${query}`,
      {},
      toolkit,
      {}
    )
  }
)
